<template>
  <div class="view-body">
      <div class="view-data view-product--add">
        <div class="row" v-if="!successMessage">
          <div class="view-data__header col">
            <h1 v-if="product.type != 6">{{title}}</h1>
            <h1 v-if="product.type == 6" class="group">
              Edycja grupy cenowej
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18px" height="20px" viewBox="0 0 18 20" version="1.1">
                  <g id="UI" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Edycja-produktu-ux---grupy-cenowe" transform="translate(-135.000000, -96.000000)" fill="#606060" fill-rule="nonzero">
                          <g id="box" transform="translate(135.000000, 96.000000)">
                              <polygon id="Path" points="10.8884319 10.1459941 10 10.6652819 10 20 18 15.3347181 18 6"/>
                              <polygon id="Path" points="12 1.63705104 9.00473244 0 1 4.36294896 3.99927193 6"/>
                              <polygon id="Path" points="17 5.0893617 13.3832168 3 5 7.9106383 5.47832168 8.16170213 8.61678322 10 11.7384615 8.17446809"/>
                              <polygon id="Path" points="4.54065251 10.9414226 3.05748317 10.1715481 3.05748317 7.77824268 0 6 0 15.334728 8 20 8 10.665272 4.54065251 8.65271967"/>
                          </g>
                      </g>
                  </g>
              </svg>
            </h1>
            <div class="product--edit-bar" v-bind:class="{ temporary: product.isTemporary, verified: product.checklistMap.examined }">
              <div class="form-group product-index">
                <input type="text" class="form-control" v-model="product.number">
              </div>
              <div class="form-group product-copy" v-if="false">
                <button class="copy-product-button">
                  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                    <g>
                      <g id="document_x5F_alt_x5F_fill">
                        <g>
                          <path style="fill:#ffffff;" d="M18,0H4v32h24V9.998L18,0z M15.918,12V4l8,8H15.918z"/>
                        </g>
                      </g>
                    </g>
                  </svg><br>
                  Kopiuj produkt
                </button>
              </div>
              <div class="form-group product-name">
                <input type="text" class="form-control" v-model="product.name">
              </div>
              <div v-if="dataFromOrder" class="form-group product-page">
                <label>Nr strony</label>
                <input type="text" class="form-control" v-model="product.pageNumber">
              </div>
              <div class="form-group form-group--checkbox">
                <div class="row">
                  <label>
                    <input type="checkbox" v-model="product.checklistMap.examined" />
                    <span class="checkbox--state"></span>
                    <span class="checkbox--name">Zweryfikowany</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="alert alert-success mt-25" v-if="successMessage">
          Produkt został dodany
        </div>
        <div @click.enter="" v-if="!successMessage">
          <div class="row">
            <div class="col col-10 col-bordered">
              <div class="container-fluid">
                <div class="row">
                  <div class="col col-5 padding-4">
                    <div class="product--details">
                      <div class="row">
                        <div class="col col-5">
                          <div class="form-group form-group--padding" :class="{ 'input-error': $v.product.number.$error || errorMessage }">
                            <label>Nr artykułu</label>
                            <input class="form-control " type="text" v-model="product.number" @focusout="insertedProductNumber(); selectCheckbox('numberInProject')" />
                            <labelInfo v-if="!$v.product.number.required" type="error" message="To pole jest wymagane"/>
                            <labelInfo v-if="errorMessage" type="error" :message="errorMessagetext" />
                          </div>
                          <div class="form-group form-group--checkbox">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.ean" />
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">EAN</span>
                              </label>
                            </div>
                            <input class="form-control " type="number" v-model="product.ean" @change="selectCheckbox('ean')"/>
                          </div>
                        </div>
                        <div class="col col-7">
                          <div class="form-group form-group--checkbox">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.numberInProject" />
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Nr artykułu w projekcie</span>
                              </label>
                            </div>
                            <input class="form-control" type="text" v-model="product.numberInProject" @change="selectCheckbox('numberInProject')"/>
                          </div>
                          <div class="container-fluid">
                            <div class="row">
                              <div class="col-6">
                                <div class="form-group form-group--checkbox">
                                  <div class="row">
                                    <label>
                                      <input type="checkbox" v-model="product.checklistMap.isHero" />
                                      <span class="checkbox--state"></span>
                                      <span class="checkbox--name">Produkt HERO</span>
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="form-group form-group--checkbox">
                                  <div class="row">
                                    <label>
                                      <input type="checkbox" v-model="product.isTemporary" @change="generatetemporaryNumber()" />
                                      <span class="checkbox--state"></span>
                                      <span class="checkbox--name">Tymczasowy</span>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col col-5">
                          <div class="form-group form-group--padding" :class="{ 'input-error': $v.product.type.$error }">
                            <label>Typ produktu</label>
                            <vueselect class="select--list select--list-small white" label="name" :options="types" :clearable="false" :searchable="false" :reduce="type => type.value" v-model="product.type">
                            <template slot="no-options">
                             <p>Brak rekordów</p>
                          </template>
                            </vueselect>
                            <labelInfo v-if="!$v.product.type.required" type="error" message="To pole jest wymagane"/>
                          </div>
                        </div>
                        <div class="col col-7">
                          <div class="container-fluid">
                            <div class="row">
                              <div class="col col-6">
                                <div class="form-group form-group--padding">
                                  <label>Widok kategorii</label>
                                  <vueselect class="select--list select--list-small white" label="name" @change="setType()" :options="views" :clearable="false" :searchable="false" :reduce="view => view.value" v-model="product.view">
                                  <template slot="no-options">
                                    <p>Brak rekordów</p>
                                  </template>
                                  </vueselect>
                                </div>
                              </div>
                              <div class="col col-6">
                                <div v-if="dataFromOrder" class="form-group form-group--padding" :class="{ 'input-error': pageNumberError != '' }">
                                  <input type="checkbox" v-model="product.checklistMap.pageNumber" style="visibility: hidden;" >
                                  <label>Nr strony</label>
                                  <input class="form-control " type="number" v-model="product.pageNumber" @change="checkPageNumber()"/>
                                  <labelInfo v-if="pageNumberError != ''" type="error" :message="pageNumberError" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.product--details -->
                    <div class="product--prices pr-25">
                      <div class="section-header">Kwoty</div>
                      <div class="row">
                        <div class="col col-4">
                          <div class="form-group form-group--checkbox">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.salePrice" />
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Cena<br>sprzedaży</span>
                              </label>
                            </div>
                            <input class="form-control " type="number" step="any" min="0" v-model="product.salePrice"  @change="selectCheckbox('salePrice')"/>
                          </div>
                        </div>
                        <div class="col col-4" v-if="product.view != 4 && product.view != 5">
                          <div class="form-group form-group--checkbox">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.currentPrice" />
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Cena<br>dotychczasowa</span>
                              </label>
                            </div>
                            <input class="form-control " type="number" step="any" min="0" v-model="product.currentPrice"  @change="selectCheckbox('currentPrice')"/>
                          </div>
                        </div>
                        <div class="col col-4" v-if="product.view != 4 && product.view != 5">
                          <div class="form-group form-group--checkbox">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.orangePrice" />
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Cena<br>z&nbsp;Orange</span>
                              </label>
                            </div>
                            <input class="form-control " type="number" step="any" min="0" v-model="product.orangePrice"  @change="selectCheckbox('orangePrice')"/>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col col-6" v-if="product.view != 4">
                          <div class="form-group form-group--checkbox">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.priceUnit" />
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Cena za szt. / zestaw / od</span>
                              </label>
                            </div>
                            <vueselect class="select--list select--list-small" label="name" :options="priceUnitValues" :clearable="true" :searchable="false" :reduce="unit => unit.value" v-model="product.priceUnitValue" @input="selectCheckbox('priceUnit')">
                            <template slot="no-options">
                              <p>Brak rekordów</p>
                            </template>
                            </vueselect>
                          </div>
                        </div>
                      </div>
                      <div class="row" v-if="product.view == 6">
                        <div class="col col-6">
                          <div class="form-group form-group--checkbox">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.satisfaction" @change="setPlug('satysfakcja-gwarantowana', product.checklistMap.satisfaction)"/>
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Satysfakcja gwarantowana</span>
                              </label>
                            </div>
                            <div class="form-group form-group--small">
                              <label>liczba dni</label>
                              <input class="form-control" type="text" v-model="product.satisfactionGuaranteeDay" @change="selectCheckbox('satisfactionGuaranteeDay'); setPlug('satysfakcja-gwarantowana', product.satisfactionGuaranteeDay);"/>
                            </div>
                            <div class="form-group form-group--small">
                              <label>szczegóły na: (adres www)</label>
                              <input class="form-control" type="text" v-model="product.satisfactionGuaranteeWeb" @change="selectCheckbox('satisfactionGuaranteeWeb')"/>
                            </div>
                          </div>
                        </div>
                        <div class="col col-6">
                          <div class="form-group form-group--checkbox">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.return" @change="setPlug('zwrot', product.checklistMap.return)"/>
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Zwrot</span>
                              </label>
                            </div>
                            <div class="form-group form-group--small">
                              <label>treść</label>
                              <input class="form-control" type="text" v-model="product.returnContent"  @change="selectCheckbox('returnContent'); setPlug('zwrot', product.returnContent)"/>
                            </div>
                            <div class="form-group form-group--small">
                              <label>szczegóły na: (adres www)</label>
                              <input class="form-control" type="text" v-model="product.returnWeb"  @change="selectCheckbox('returnWeb')"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col col-6">
                          <div class="form-group form-group--checkbox" v-if="product.view == 3 || product.view == 6">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.giftCard" />
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Karta podarunkowa</span>
                              </label>
                            </div>
                            <vueselect class="select--list select--list-small" label="name" :options="giftCards" @input="selectCheckbox('giftCard')" :reduce="card => card.value" v-model="product.giftCard">
                            <template slot="no-options">
                              <p>Brak rekordów</p>
                            </template>
                            </vueselect>
                          </div>
                          <div class="form-group form-group--small form-group--padding" v-if="product.view == 3 || product.view == 6">
                            <label>kwota</label>
                            <input class="form-control" type="text" v-model="product.giftCardValue"  @change="selectCheckbox('giftCardValue')"/>
                          </div>
                        </div>
                        <div class="col col-6" v-if="product.view == 3 || product.view == 6">
                          <div class="form-group form-group--checkbox">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.isGuaranteePlus" />
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Gwarancja PLUS</span>
                              </label>
                            </div>
                            <vueselect label="name" :options="[{name: 'od', value: 1}]" :searchable="false" class="select--list select--list-small" :reduce="guarantee => guarantee.value" v-model="product.isGuaranteePlus" @input="selectCheckbox('guaranteePlusAmount')">
                            <template slot="no-options">
                              <p>Brak rekordów</p>
                            </template>
                            </vueselect>
                          </div>
                          <div class="form-group form-group--small form-group--padding">
                            <label>kwota</label>
                            <input class="form-control" type="number" v-model="product.guaranteePlusAmount" @change="selectCheckbox('guaranteePlusAmount')" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.product--prices -->
                    <div class="product--dates">
                      <div class="section-header">Dostepność</div>
                      <div class="row">
                        <div class="col col-6">
                          <div class="row">
                            <div class="col col-6">
                              <div class="form-group form-group--checkbox form-group--date" v-bind:class="{ 'hide-date': product.availabilityFrom != '' }" v-if="product.view == 5 || product.view == 6">
                                <label>
                                  <input type="checkbox" v-model="product.checklistMap.availabilityFrom" />
                                  <span class="checkbox--state"></span>
                                  <span class="checkbox--name">Oferta od</span>
                                </label>
                                <!-- <input class="form-control" type="date" v-model="product.availabilityFrom"  @change="selectCheckbox('availabilityFrom')"/> -->
                                <datepicker :popperProps="popperProps" :value="product.availabilityFrom" :dayStr="['7', '1', '2', '3', '4', '5', '6']" class="form-control" v-model="product.availabilityFrom" @change="selectCheckbox('availabilityFrom')" @input="product.availabilityFrom ? selectCheckbox('availabilityFrom') : false" />
                                <span class="date"><img class="list-icon" src="@/assets/symbols/calendar.svg"/></span>
                              </div>
                            </div>
                            <div class="col col-6">
                              <div class="form-group form-group--checkbox form-group--date" v-bind:class="{ 'hide-date': product.availabilityTo != '' }" v-if="product.view == 5 || product.view == 6">
                                <label>
                                  <input type="checkbox" v-model="product.checklistMap.availabilityTo" />
                                  <span class="checkbox--state"></span>
                                  <span class="checkbox--name">Oferta do</span>
                                </label>
                                <!-- <input class="form-control" type="date" v-model="product.availabilityTo"  @change="selectCheckbox('availabilityTo')"/> -->
                                <datepicker :popperProps="popperProps" :value="product.availabilityTo" :dayStr="['7', '1', '2', '3', '4', '5', '6']" class="form-control" v-model="product.availabilityTo" @change="selectCheckbox('availabilityTo')" @input="product.availabilityTo ? selectCheckbox('availabilityTo') : false" />
                                <span class="date"><img class="list-icon" src="@/assets/symbols/calendar.svg"/></span>
                              </div>
                            </div>
                          </div>
                          <div class="form-group form-group--checkbox" v-if="product.view == 6">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.availabilityCommunique" />
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Dodatkowy komunikat</span>
                              </label>
                            </div>
                            <textarea class="form-control  form-control-textarea" style="min-height: 60px;" type="text" v-model="product.availabilityCommunique" @change="selectCheckbox('availabilityCommunique')"></textarea>
                          </div>
                        </div>
                        <div class="col col-6 pr-25">
                          <div class="form-group form-group--checkbox form-group--date" v-bind:class="{ 'hide-date': product.premiereDate != '' }" v-if="product.view == 5 || product.view == 6">
                            <label>
                              <input type="checkbox" v-model="product.checklistMap.premiereDate" />
                              <span class="checkbox--state"></span>
                              <span class="checkbox--name">Premiera</span>
                            </label>
                            <!-- <input class="form-control" type="date" v-model="product.premiereDate"  @change="selectCheckbox('premiereDate')"/> -->
                            <datepicker :popperProps="popperProps" :value="product.premiereDate" :dayStr="['7', '1', '2', '3', '4', '5', '6']" class="form-control" v-model="product.premiereDate" @change="selectCheckbox('premiereDate')" @input="product.premiereDate ? selectCheckbox('premiereDate') : false" />
                            <span class="date"><img class="list-icon" src="@/assets/symbols/calendar.svg"/></span>
                          </div>
                          <div class="form-group form-group--checkbox" v-if="product.view == 5 || product.view == 6">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.availabilityIcon" />
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Dostępny również na (ikona)</span>
                              </label>
                            </div>
                            <input class="form-control" type="text" v-model="product.availabilityIcon"  @change="selectCheckbox('availabilityIcon')"/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.product--dates -->
                    <div class="product--lagals">
                      <div class="row">
                        <div class="col">
                          <div class="form-group form-group--checkbox" v-if="product.view == 6">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.legalSentence" />
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Zdanie prawne</span>
                              </label>
                              <input class="form-control " type="text" v-model="product.legalSentence"  @change="selectCheckbox('legalSentence')"/>
                            </div>
                          </div>
                          <div class="form-group form-group--padding">
                            <div class="row">
                              <label>Uwagi dla Agencji</label>
                            </div>
                            <textarea class="form-control form-control-textarea" style="min-height: 60px;" type="text" v-model="product.comment" ></textarea>
                          </div>
                          <div class="form-group form-group--padding">
                            <div class="row">
                              <label>Notatka</label>
                            </div>
                            <textarea class="form-control form-control-textarea" style="min-height: 60px;" type="text" v-model="product.note" ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.product--lagals -->
                  </div>
                  <div class="col col-5 padding-4 padding-bottom-50">
                    <div class="product--technical-details">
                      <div class="section-header">Dane techniczne</div>
                      <div class="row">
                        <div class="col col-6">
                          <div class="form-group form-group--checkbox" v-if="product.view != 5">
                            <label>
                              <input type="checkbox" v-model="product.checklistMap.producer" />
                              <span class="checkbox--state"></span>
                              <span class="checkbox--name">Producent</span>
                            </label>
                            <input class="form-control " type="text" style="text-transform: uppercase;" v-model="product.producer" @focusout="writeProductName()"  @change="selectCheckbox('producer'); getProducerLogoImage()"/>
                          </div>
                          <div class="form-group form-group--checkbox">
                            <label>
                              <input type="checkbox" v-model="product.checklistMap.name" />
                              <span class="checkbox--state"></span>
                              <span class="checkbox--name">Nazwa produktu</span>
                            </label>
                            <textarea class="form-control form-control-textarea" style="min-height: 60px;" type="text" v-model="product.name" @change="selectCheckbox('name')"></textarea>
                          </div>
                          <div class="form-group form-group--checkbox" v-if="product.view != 5">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.description" />
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Opis produktu w bulletach</span>
                              </label>
                              <textarea class="form-control  form-control-textarea" type="text" v-model="product.description"  @change="selectCheckbox('description')"></textarea>
                            </div>
                          </div>
                          <div class="form-group form-group--checkbox" v-if="product.view == 3 || product.view == 5 || product.view == 6">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.longDescription" />
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Opis produktu bez bulletów</span>
                              </label>
                              <textarea class="form-control  form-control-textarea" type="text" v-model="product.longDescription" @change="selectCheckbox('longDescription')"></textarea>
                            </div>
                          </div>
                          <div class="form-group form-group--checkbox" v-if="product.view != 4 && product.view != 5">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.whiteArrowText" />
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Tekst w białej strzałce</span>
                              </label>
                              <input class="form-control " type="text" v-model="product.whiteArrowText"  @change="selectCheckbox('whiteArrowText')"/>
                            </div>
                          </div>
                          <div class="form-group form-group--checkbox" v-if="product.view !=4 && product.view !=5">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.whiteFrameText" @change="setPlug('tekst-do-apli', product.checklistMap.whiteFrameText)"/>
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Tekst do białej apli</span>
                              </label>
                              <input class="form-control " type="text" v-model="product.whiteFrameText"  @change="selectCheckbox('whiteFrameText'); setPlug('tekst-do-apli', product.whiteFrameText)"/>
                            </div>
                          </div>
                        </div>
                        <div class="col col-6 pr-25">
                          <div class="form-group form-group--checkbox" v-if="product.view == 3 || product.view == 6">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.diagonal" />
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Przekątna / rodzaj ekranu</span>
                              </label>
                              <div class="row form-group--small-padding">
                                <div class="form-group form-group--small col col-4">
                                  <label>cale</label>
                                  <input class="form-control" type="text" v-model="product.diagonalInIn"  @change="selectCheckbox('diagonalInIn')"/>
                                </div>
                                <div class="form-group form-group--small col col-4">
                                  <label>cm</label>
                                  <input class="form-control" type="text" v-model="product.diagonalInCm"  @change="selectCheckbox('diagonalInCm')"/>
                                </div>
                                <div class="form-group form-group--small col col-4">
                                  <label>rodzaj</label>
                                  <input class="form-control" type="text" v-model="product.displayType"  @change="selectCheckbox('displayType')"/>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group form-group--checkbox" v-if="product.view == 1 || product.view == 6">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.dimensions" />
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Wymiary w cm</span>
                              </label>
                              <div class="row form-group--small-padding">
                                <div class="form-group form-group--small col col-4">
                                  <label>szer.</label>
                                  <input class="form-control" type="number" v-model="product.width"  @change="selectCheckbox('width')"/>
                                </div>
                                <div class="form-group form-group--small col col-4">
                                  <label>wys.</label>
                                  <input class="form-control" type="number" v-model="product.height"  @change="selectCheckbox('height')"/>
                                </div>
                                <div class="form-group form-group--small col col-4">
                                  <label>gł.</label>
                                  <input class="form-control" type="number" v-model="product.depth"  @change="selectCheckbox('depth')"/>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group form-group--checkbox" v-if="product.view == 1 || product.view == 6">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.energeticClass" @change="setPlug('klasa-energetyczna', product.checklistMap.energeticClass)"/>
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Klasa energetyczna</span>
                              </label>
                              <div class="container-fluid">
                                <vueselect class="select--list select--list-small" label="name" :options="energeticClasses" @input="setEnergeticClass($event); selectCheckbox('energeticClass'); setPlug('klasa-energetyczna', energeticClass)" :searchable="false" v-model="energeticClass">
                                  <template slot="no-options">
                                    <p>Brak rekordów</p>
                                  </template>
                                </vueselect>
                              </div>
                            </div>
                          </div>
                          <div class="form-group form-group--checkbox" v-if="product.view == 1 || product.view == 6">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.batchWeight" @change="setPlug('waga-wsadu', product.checklistMap.batchWeight)"/>
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Waga wsadu</span>
                              </label>
                              <div class="row form-group--small-padding">
                                <div class="form-group form-group--small col col-6">
                                  <label>kg</label>
                                  <input class="form-control" type="number" v-model="product.batchWeight"  @change="selectCheckbox('batchWeight'); setPlug('waga-wsadu', product.batchWeight)"/>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group form-group--checkbox" v-if="product.view == 1 || product.view == 6">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.setsOfDishes" @change="setPlug('kompletow-naczyn', product.checklistMap.setsOfDishes)"/>
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Liczba kompletów naczyń</span>
                              </label>
                              <input class="form-control " type="number" v-model="product.setsOfDishes"  @change="selectCheckbox('setsOfDishes'); setPlug('kompletow-naczyn', product.setsOfDishes)"/>
                            </div>
                          </div>
                          <div class="form-group form-group--checkbox" v-if="product.view == 1 || product.view == 6">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.rpm" @change="setPlug('liczba-obrotow', product.checklistMap.rpm)"/>
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Liczba obrotów na minutę</span>
                              </label>
                              <input class="form-control" type="number" v-model="product.rpm"  @change="selectCheckbox('rpm'); setPlug('liczba-obrotow', product.rpm)"/>
                            </div>
                          </div>
                          <div class="form-group form-group--checkbox" v-if="product.view == 1 || product.view == 6">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.capacity" @change="setPlug('pojemnosc', product.checklistMap.capacity)"/>
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Pojemność</span>
                              </label>
                              <div class="row form-group--small-padding">
                                <div class="form-group form-group--small col col-6">
                                  <label>l</label>
                                  <input class="form-control" type="number" v-model="product.capacity"  @change="selectCheckbox('capacity'); setPlug('pojemnosc', product.capacity)"/>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group form-group--checkbox" v-if="product.view !=4 && product.view !=5">
                            <div class="row">
                              <label>
                                <input type="checkbox" v-model="product.checklistMap.colors" @change="setPlug('dostepny-w-kolorach', product.checklistMap.colors)"/>
                                <span class="checkbox--state"></span>
                                <span class="checkbox--name">Dodatkowe kolory</span>
                              </label>
                            </div>
                            <ul class="selected-colors list-inline list-unstyled">
                              <li v-for="(color, index) in selectedColors">
                                <div class="square" v-bind:style="{ 'background-color': color.code }" @click="removeColor(index)" v-b-tooltip.hover :title="color.tooltip"></div>
                              </li>
                            </ul>
                            <ul class="colors-list list-inline list-unstyled">
                              <p>Wybierz kolor</p>
                              <li v-for="(color, index) in avaliableColors">
                                <div class="square" v-bind:style="{ 'background-color': color.code }" @click="addColor(index); selectCheckbox('colors')" v-b-tooltip.hover :title="color.tooltip"></div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.product--technical-details -->
                    <div class="product--icons">
                      <div class="row">
                        <div class="col-7">
                          <div class="section-header">Ikony</div>
                          <div class="icons-relative-wrapper">
                            <ul class="icons-list--duplicated list-unstyled list-inline">
                              <li v-for="i in 9">{{ i }}</li>
                            </ul>
                            <draggable class="icons-list list-unstyled list-inline" :list="product.productImages.icons" group="images" @change="listIconChange">
                              <li v-for="image in product.productImages.icons" class="small-icon-list-element is-choosen" v-b-tooltip.hover :title="image.name">
                                <img :src="image.href" :alt="image.name" />
                                <div class="image--remove" @click="removeProductImage(image, product.productImages.icons)">
                                  <svg id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><rect fill="#e3000b" width="14" height="14"/><line style="stroke:#fff;" x1="0.59" y1="0.59" x2="13.29" y2="13.29"/><line style="stroke:#fff;" x1="13.34" y1="0.66" x2="0.66" y2="13.34"/></svg>
                                </div>
                                <div class="name--zoom name--zoom-alone" @click="displayImagePopup(image)">
                                  <img src="@/assets/symbols/zoom-in.svg" />
                                </div>
                                <span class="image__quality--not-accepted" v-if="image.quality.length === 0">!</span>
                                <div class="image__quality" v-if="image.quality.length > 0">
                                  <div class="quality__star--fill" v-for="star in image.quality.length"></div>
                                  <div class="quality__star" v-for="star in 4-image.quality.length"></div>
                                </div>
                              </li>
                            </draggable>
                          </div>
                        </div>
                        <div class="col-5">
                          <div class="section-header">Znak wodny</div>
                          <div class="icons-relative-wrapper">
                            <ul class="watermarks-list--duplicated list-unstyled list-inline">
                              <li v-for="i in 2">{{ i }}</li>
                            </ul>
                            <draggable class="watermarks-list list-unstyled list-inline" :list="product.productImages.watermarks" group="images" @change="listWatermarkChange">
                              <li v-for="image in product.productImages.watermarks" class="small-icon-list-element is-choosen" v-b-tooltip.hover :title="image.name">
                                <img :src="image.href" :alt="image.name" />
                                <div class="image--remove" @click="removeProductImage(image, product.productImages.watermarks)">
                                  <svg id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><rect fill="#e3000b" width="14" height="14"/><line style="stroke:#fff;" x1="0.59" y1="0.59" x2="13.29" y2="13.29"/><line style="stroke:#fff;" x1="13.34" y1="0.66" x2="0.66" y2="13.34"/></svg>
                                </div>
                                <div class="name--zoom name--zoom-alone" @click="displayImagePopup(image)">
                                  <img src="@/assets/symbols/zoom-in.svg" />
                                </div>
                                <span class="image__quality--not-accepted" v-if="image.quality.length === 0">!</span>
                                <div class="image__quality" v-if="image.quality.length > 0">
                                  <div class="quality__star--fill" v-for="star in image.quality.length"></div>
                                  <div class="quality__star" v-for="star in 4-image.quality.length"></div>
                                </div>
                              </li>
                            </draggable>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </div>

                  <div class="col col-2 padding-4 padding-bottom-50">
                    <div class="product__price-group clearfix" v-if="product.type == 6">
                      <div class="section-header">Lista produktów z grupy cenowej</div>
                      <vuescroll :ops="scrollOptions">
                        <draggable class="price-group--list list-unstyled" :list="priceGroups" group="products">
                          <li class="price-group--element" v-for="product in priceGroups">
                            <div class="price-group--element-content">
                              <div class="remove" @click="removeProductFromPriceGroup(product)">
                                <svg id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><rect fill="#e3000b" width="14" height="14"/><line style="stroke:#fff;" x1="0.59" y1="0.59" x2="13.29" y2="13.29"/><line style="stroke:#fff;" x1="13.34" y1="0.66" x2="0.66" y2="13.34"/></svg>
                              </div>
                              <span>
                                <p>{{product.number}}</p>
                                <p>{{product.name}}</p>
                              </span>
                            </div>
                            <div class="price-group--element-image">
                              <img v-bind:src="findMainImage(product)">
                            </div>
                          </li>
                        </draggable>
                      </vuescroll>
                    </div>
                    <div class="product--images">
                      <div class="button-group graphic-control">
                      <!--<span class="button-module-table" @click="uploadPopup = true">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 504 504" style="enable-background:new 0 0 504 504;" xml:space="preserve" width="512px" height="512px">
                          <g>
                            <path d="M311.3,108.74c-15.304,0-27.752,12.444-27.752,27.752c0.004,15.3,12.452,27.744,27.752,27.744s27.752-12.44,27.752-27.744    C339.052,121.188,326.604,108.74,311.3,108.74z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#E02020"/>
                          </g>
                          <g>
                            <path d="M252.164,286.1c-49.992,0-90.508,40.52-90.508,90.5c0,49.984,40.516,90.508,90.508,90.508s90.512-40.524,90.512-90.508    C342.676,326.62,302.156,286.1,252.164,286.1z M303.148,387.328h-39.336v40.344c0,6.476-5.336,11.744-11.812,11.744    s-11.812-5.264-11.812-11.744v-40.344h-39.172c-6.476,0-11.748-5.336-11.748-11.812s5.268-11.812,11.748-11.812h39.172v-38.168    c0-6.472,5.336-11.744,11.812-11.744s11.812,5.268,11.812,11.744v38.168h39.336c6.476,0,11.748,5.336,11.748,11.812    S309.624,387.328,303.148,387.328z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#E02020"/>
                          </g>
                          <g>
                            <path d="M484.356,36.892H19.976C9.12,36.892,0,46.56,0,57.416v299.496c0,10.86,9.12,18.6,19.976,18.6h118.056    c0-63,51.2-114.124,114.132-114.124c62.936,0,114.136,51.124,114.136,114.124h118.056c10.856,0,19.644-7.744,19.644-18.6V57.416    C504,46.56,495.212,36.892,484.356,36.892z M391.5,172.552l-74.456,74.472L203.712,133.708c-1.54-1.54-4.024-1.54-5.564,0    l-71.884,71.88l-32.816-32.812c-1.536-1.54-4.172-1.54-5.708,0l-52.304,52.16V72.328H468.56v171.748l-71.5-71.524    C395.52,171.012,393.04,171.012,391.5,172.552z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#E02020"/>
                          </g>
                        </svg>
                        <p>Prześlij grafiki</p>
                      </span>-->
                      </div>
                      <div class="section-header">Grafika</div>
                      <div class="images--logo">
                        <div class="form-group">
                          <label class="light">Logo główne</label>
                          <div class="empty-drag-area" v-if="product.productImages.main_logo && product.productImages.main_logo.length === 0">Przenieś grafikę tutaj</div>
                          <draggable class="list--logo" :list="product.productImages.main_logo" group="images" @change="listLogoChange" :options="{disabled: product.productImages.main_logo && product.productImages.main_logo.length === 1}">
                            <div class="product-image-logo" v-for="image in product.productImages.main_logo" :key="image.id" @click="changeLogoStatus" :class="{ 'is-main': image.isChoosen == 2 }" v-b-tooltip.hover :title="image.name"> 
                              <img :src="image.href" :alt="image.name" />
                              <div class="name--zoom name--zoom-alone" @click="displayImagePopup(image)">
                                <img src="@/assets/symbols/zoom-in.svg" />
                              </div>
                              <span class="image__quality--not-accepted" v-if="image.quality.length === 0">!</span>
                              <div class="image__quality" v-if="image.quality.length > 0">
                                <div class="quality__star--fill" v-for="star in image.quality.length"></div>
                                <div class="quality__star" v-for="star in 4-image.quality.length"></div>
                              </div>
                            </div>
                          </draggable>
                        </div>
                      </div>
                      <div class="images--additional-logo">
                        <div class="form-group">
                          <label class="light">Loga dodatkowe</label>
                          <div class="empty-drag-area" v-if="product.productImages.additional_logo.length === 0">Przenieś grafiki tutaj</div>
                          <draggable class="list--additional-logo list-unstyled list-inline" :list="product.productImages.additional_logo" group="images" @change="listAdditionalLogoChange">
                            <li v-for="image in product.productImages.additional_logo" class="is-choosen" v-b-tooltip.hover :title="image.name">
                              <img :src="image.href" :alt="image.name" />
                              <div class="name--zoom name--zoom-alone" @click="displayImagePopup(image)">
                                <img src="@/assets/symbols/zoom-in.svg" />
                              </div>
                              <div class="image--remove" @click="removeProductImage(image, product.productImages.additional_logo)">
                                <svg id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><rect fill="#e3000b" width="14" height="14"/><line style="stroke:#fff;" x1="0.59" y1="0.59" x2="13.29" y2="13.29"/><line style="stroke:#fff;" x1="13.34" y1="0.66" x2="0.66" y2="13.34"/></svg>
                              </div>
                              <span class="image__quality--not-accepted" v-if="image.quality.length === 0">!</span>
                              <div class="image__quality" v-if="image.quality.length > 0">
                                <div class="quality__star--fill" v-for="star in image.quality.length"></div>
                                <div class="quality__star" v-for="star in 4-image.quality.length"></div>
                              </div>
                            </li>
                          </draggable>
                        </div>
                      </div>
                      <div class="images--selected-images">
                        <div class="form-group">
                          <label class="light">Wybrane grafiki</label>
                          <div class="preselected__images--wrapper">
                            <vuescroll :ops="scrollOptions">
                              <div class="empty-drag-area" v-if="product.productImages.photos.length === 0">Przenieś grafiki tutaj</div>
                              <draggable v-model="product.productImages.photos" class="preselected__images list-unstyled clearfix" :class="{ empty: product.productImages.photos.length === 0 }" group="images" @change="listImagesChange">
                                <li v-for="image in product.productImages.photos" :key="image.id" class="is-choosen" :class="{ 'is-main': image.isChoosen === 2 }">
                                  <img :src="image.href" :alt="image.name" @click="setImageStatus(image)"/>
                                  <span class="info">
                                    i
                                    <div class="image-info-content">
                                      Wielkość w px: {{ image.qualityWidth }}x{{ image.qualityHeight }}<br>
                                      Wielkość w cm przy 300 dpi: {{ image.cmWidth }} x {{ image.cmHeight }}
                                    </div>
                                  </span>
                                  <span class="name">
                                    <div class="name--zoom" @click="displayImagePopup(image)">
                                      <img src="@/assets/symbols/zoom-in.svg" />
                                    </div>
                                    {{ image.name }}
                                  </span>
                                  <div class="image--remove" @click="removeProductImage(image, product.productImages.photos); refreshPreselectedImages()">
                                    <svg id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><rect fill="#e3000b" width="14" height="14"/><line style="stroke:#fff;" x1="0.59" y1="0.59" x2="13.29" y2="13.29"/><line style="stroke:#fff;" x1="13.34" y1="0.66" x2="0.66" y2="13.34"/></svg>
                                  </div>
                                  <span class="image__quality--not-accepted" v-if="image.quality.length === 0">!</span>
                                  <div class="image__quality" v-if="image.quality.length > 0">
                                    <div class="quality__star--fill" v-for="star in image.quality.length"></div>
                                    <div class="quality__star" v-for="star in 4-image.quality.length"></div>
                                  </div>
                                </li>
                              </draggable>
                            </vuescroll>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="buttons--wrapper">
                <div class="product--buttons">
                  <router-link v-if="dataFromOrder !== null" class="button button-add-product mt-10" :to="{ name: 'OrderEdit', params: { id: dataFromOrder.orderId}}">Wróć</router-link>
                  <button type="submit" class="button button-add-product" @click="onSubmit">Zapisz</button><br>
                </div>
              </div>
            </div>
            <div class="col-2 no-padding">
              <globalSearch :view="'product'" ref="globalSearch" :usedGraphics="product.productImages" v-bind:productId="1" v-bind:productNumber="product.number" v-bind:productType="product.view"></globalSearch>
            </div>
          </div>
        </div>
      </div>
      <imagePopup v-if="showImagePopup" v-bind:image="imageToEnlarge"></imagePopup>

      <filePopup v-if="uploadPopup" :showFields="true" @confirm="uploadPopup = false; setUploadedImages($event)" @cancel="uploadPopup = false"/>

  </div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import labelInfo from '@/components/blocks/labelInfo.vue'
import globalSearch from '@/components/blocks/globalSearch.vue'
import imagePopup from '@/components/blocks/product/imagePopup'
import draggable from 'vuedraggable';
import vuescroll from 'vuescroll';
import MaskedInput from 'vue-masked-input' 
import filePopup from '@/components/blocks/files/filePopup.vue';

export default {
  name: 'ProductAdd',
  components: {
    labelInfo,
    globalSearch,
    draggable,
    MaskedInput,
    vuescroll,
    imagePopup,
    filePopup,
  },
  mixins: [validationMixin],
  validations: {
    product: {
      number: { required },
      type: { required }
    }
  },
  data () {
    return {
      title: 'Nowy produkt',

      dataFromOrder: null,
      priceGroups: [],
      imageToEnlarge: '',
      pageNumberError: '',
      showImagePopup: false,
      uploadPopup: false,

      popperProps: {
          arrowPosition: 'start',
          arrowOffsetScaling: 1,
          popperOptions: {
              placement: 'bottom-start',
              positionFixed: true,
              modifiers: {
                  flip: {
                      behavior: ['left', 'right', 'bottom', 'top']
                  },
                  preventOverflow: {
                      boundariesElement: document.querySelector('.hot-module__body'),
                  },
              },
          },
      },

      product: {
        view: '6',
        type: "",
        name: "",
        number: "",
        pageNumber: "",
        ean: "",
        showPrice: false,
        comment: "",
        note: "",
        numberInProject: "",
        producer: "",
        description: "",
        currentPrice: "",
        showCurrentPrice: false,
        orangePrice: "",
        showOrangePrice: false,
        priceUnit: "",
        priceUnitValue: "",
        whiteFrameText: "",
        whiteArrowText: "",
        colors: [],
        width: "",
        height: "",
        depth: "",
        energeticClass: "",
        rpm: "",
        setsOfDishes: "",
        batchWeight: "",
        capacity: "",
        diagonalInCm: "",
        diagonalInIn: "",
        displayType: "",
        giftCard: false,
        giftCardValue: "",
        isGuaranteePlus: false,
        premiereDate: "",
        longDescription: "",
        availabilityFrom: "",
        availabilityTo: "",
        availabilityCommunique: "",
        availabilityIcon: "",
        legalSentence: "",
        salePrice: "",
        showSalePrice: true,
        satisfactionGuaranteeDay: "",
        returnContent: "",
        returnWeb: "",
        modelName: "",
        wwsName: "",
        priceGroups: [
          {
            name: '',
            priceGroupProducts: [],
            active: 1,
          }
        ],
        productImages: {
          main_logo: [],
          additional_logo: [],
          photos: [],
          icons: [],
          watermarks: []
        },
        isTemporary: false,
        checklistMap: {
          name: false,
          numberInProject: false,
          ean: false,
          pageNumber: false,
          producer: false,
          modelName: false,
          description: false,
          longDescription: false,
          whiteArrowText: false,
          whiteFrameText: false,
          colors: false,
          salePrice: false,
          currentPrice: false,
          orangePrice: false,
          priceUnit: false,
          satisfaction: false,
          isGuaranteePlus: false,
          guaranteePlusAmount: false,
          return: false,
          giftCard: false,
          availabilityFrom: false,
          availabilityTo: false,
          availabilityIcon: false,
          availabilityCommunique: false,
          premiereDate: false,
          diagonal: false,
          dimensions: false,
          energeticClass: false,
          rpm: false,
          capacity: false,
          setsOfDishes: false,
          batchWeight: false,
          legalSentence: false,
          isHero: false,
          comment: true,
          note: true,
          mainImage: false,
          additionalImages: false,
          mainLogo: false,
          additionalLogo: false,
          iconInArrow: false,
          iconOutArrow: false,
          examined: false
        }
      },
      productGroup: [],
      energeticClass: '',
      avaliableColors: [
        { code: '#41C0F0', tooltip: 'Błękitny' },
        { code: '#0063AF', tooltip: 'Niebieski' },
        { code: '#1B2D70', tooltip: 'Granatowy' },
        { code: '#662483', tooltip: 'Fioletowy' },
        { code: '#FFED00', tooltip: 'Żółty' },
        { code: '#EC6608', tooltip: 'Pomarańczowy' },
        { code: '#E30613', tooltip: 'Czerwony' },
        { code: '#EA5297', tooltip: 'Różowy' },
        { code: '#FFFFFF', tooltip: 'Biały' },
        { code: '#000000', tooltip: 'Czarny' },
        { code: '#C9D8E1', tooltip: 'Srebrny' },
        { code: '#B2B2B2', tooltip: 'Jasnoszary' },
        { code: '#878787', tooltip: 'Ciemnoszary' },
        { code: '#E1B71A', tooltip: 'Złoty' },
        { code: '#13A538', tooltip: 'Zielony' },
        { code: '#78380A', tooltip: 'Brązowy' }
      ],
      selectedColors: [],
      views: [
        { name: 'Duże AGD', value: '1' },
        { name: 'Małe AGD', value: '2' },
        { name: 'RTV, komputery, telefony, konsole', value: '3' },
        { name: 'Akcesoria komputerowe', value: '4' },
        { name: 'Książki, filmy, gry', value: '5' },
        { name: 'Pełen widok', value: '6' },
      ],
      types: [
        { name: 'Standardowy', value: 1 },
        { name: 'Opisowy', value: 2 },
        { name: 'Grafika', value: 3 },
        { name: 'Stopka', value: 4 },
        { name: 'Usługa', value: 5 },
        { name: 'Grupa cenowa', value: 6 },
      ],
      priceUnits: [
        { name: 'PLN', value: '1' },
      ],
      priceUnitValues: [
        { name: 'Cena od',value: 1 },
        { name: 'Cena za sztukę',value: 2 },
        { name: 'Cena za zestaw',value: 3 },
      ],

      giftCards: [
        { name: 'MM',value: '1' },
        { name: 'BP',value: '2' },
        { name: 'Carrefour',value: '3' },
        { name: 'Douglas',value: '4' },
        { name: 'Decathlon',value: '5' },
      ],

      energeticClasses: [
        { name: 'A+++', value: 1 },
        { name: 'A++', value: 2 },
        { name: 'A+', value: 3 },
        { name: 'A', value: 4 },
        { name: 'B', value: 5 },
        { name: 'C', value: 6 },
        { name: 'D', value: 7 },
        { name: 'E', value: 8 },
        { name: 'F', value: 9 },
        { name: 'G', value: 10 },
      ],
      errorMessage: false,
      errorMessagetext: '',
      successMessage: false,
      images: [],
      scrollOptions: {
        rail: {
          background: '#D8D8D8',
          opacity: 1,
          size: '10px',
          gutterOfEnds: '0px',
          border: '2px solid #D8D8D8'
        },
        scrollPanel: {
          scrollingY: true,
          scrollingX: false,
        },
        bar: {
          background: '#939393',
          keepShow: true,
          opacity: 1,
          hoverStyle: false,
          specifyBorderRadius: '5px',
          size: '6px'
        }
      }
    }
  },
  watch: {
    'product.productImages.photos': (val) => {
      if ( val.length === 1 ) {
        val[0].isChoosen = 2;
      }
    }
  },
  methods: {

    setUploadedImages(e){

      const images = e.images;
      const newField = e.field.code;

      if(images){

        images.forEach(item =>{

          item.quality = '';

          const newObject = {
            added:{
              element: item
            }
          }

          switch(newField){

            case 'logo':
              this.listLogoChange(newObject);
            break;

            case 'logo_addtional':
              this.product.productImages.additional_logo.push(item);
              //this.listAdditionalLogoChange(newObject);
            break;

            case 'selected':
              this.product.productImages.photos.push(item);
              this.listImagesChange(newObject);
            break;

            case 'icons':
              this.product.productImages.icons.push(item);
              this.listIconChange(newObject);
            break;

            case 'watermark':
              this.product.productImages.watermarks.push(item);
              this.listWatermarkChange(newObject);
            break;

          }

        });

      }

    },

    setPlug(fieldPlug, content){

      const token = localStorage.getItem('auth_token');

      this.$http.get(`product-images/${fieldPlug}/plug`, {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          if(!response.data.error){

            let exist   = this.product.productImages.icons.find(item =>  item.id === response.data.productImage.id );
            
            if(exist && !content){
            
              this.product.productImages.icons = this.product.productImages.icons.filter(item =>  item.id !== response.data.productImage.id );
              return;

            }
            
            if(!exist && content){
            
              this.product.productImages.icons.push(response.data.productImage);

            }

            let resultIndex   = this.product.productImages.icons.findIndex(item =>  item.id === response.data.productImage.id );

            if ( this.product.productImages.icons.length > 9 ) {

              this.product.productImages.icons.splice(resultIndex, 1);

            }

          }

        })
        .catch(error =>{

          console.error(error.response);

        })

    },

    selectCheckbox(item) {
      if ( item ) {

        if ( item == 'width' || item == 'height' || item == 'depth' ) {
          this.product.checklistMap.dimensions = true;
        }
        if ( item == 'diagonalInIn' || item == 'diagonalInCm' || item == 'displayType' ) {
          this.product.checklistMap.diagonal = true;
        }

        if ( item == 'numberInProject' || this.product.numberInProject !== '' ) {
          this.product.checklistMap.numberInProject = true;
        }

        if ( item == 'returnContent' || item == 'returnWeb' ) {
          this.product.checklistMap.return = true;
        }

        if ( item == 'guaranteePlusAmount' || this.product.isGuaranteePlus.value ) {
          this.product.checklistMap.isGuaranteePlus = true;
        }

        if ( item == 'satisfactionGuaranteeDay' || item == 'satisfactionGuaranteeWeb' ) {
          this.product.checklistMap.satisfaction = true;
        }

        if ( item == 'giftCard' || item == 'giftCardValue' ) {
          this.product.checklistMap.giftCard = true;
        }

        if ( typeof(this.product.checklistMap[item]) == 'undefined' ) {
          return;
        }
        this.product.checklistMap[item] = true;
      }
    },

    backToOrder() {
      if ( this.dataFromOrder !== null ) {
        this.$router.push(`/order/${this.dataFromOrder.orderId}/edit`);
      }
    },

    changeLogoStatus() {

      this.product.productImages.main_logo[0].isChoosen === 2 ? this.product.productImages.main_logo[0].isChoosen = 1 : this.product.productImages.main_logo[0].isChoosen = 2;
      this.product.checklistMap.pageNumber = !this.product.checklistMap.pageNumber;

    },

    setImageStatus(image) {

      let id        = image.id;
      let selected  = this.product.productImages.photos.find(item =>  item.isChoosen === 2 );
      if ( selected ) {
        selected.isChoosen = 1;
      }

      let result  = this.product.productImages.photos.find(item =>  item.id === id );
      if ( result.isChoosen === 1 ) {
        result.isChoosen = 2;
      }

      // Tricky - update DOM w celu zaktualizowania danych dla draggable
      this.product.checklistMap.ean = true;
      setTimeout(()=>{
        this.product.checklistMap.ean = false;
      }, 10);

    },

    removeProductImage(image, list) {
      list.forEach((item, index)=>{
        if ( item.id === image.id ) {
          list.splice(index, 1);
        }
      });

      let selected = this.product.productImages.photos.find(item => item.isChoosen == 2);
      if ( !selected && this.product.productImages.photos.length ) {
        this.product.productImages.photos[0].isChoosen = 2;
      }

      this.product.checklistMap.pageNumber = !this.product.checklistMap.pageNumber;

    },

    generatetemporaryNumber() {

      if ( this.product.isTemporary ) {
        const token = localStorage.getItem('auth_token');

        this.$http.get(`/product/temporary/number`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }).then(response => {
          if ( response.data.number ) {
            this.product.number = response.data.number;
            this.insertedProductNumber();
          }
        });
      }

    },

    displayImagePopup(image) {
      this.showImagePopup = true;
      this.imageToEnlarge = image;
    },

    insertedProductNumber() {

        if ( this.product.numberInProject && !this.product.numberInProject.toString().includes(this.product.number.toString())) {
          this.product.numberInProject = this.product.number + ', ' + this.product.numberInProject;
        } else {
          this.product.numberInProject = this.product.number;
        }

      this.$refs.globalSearch.getPreselectedImages();
    },

    setProductImage(id, image, category) {
      const token = localStorage.getItem('auth_token');

      this.$http.put(`/products/${id}/images/${image.id}/categories/${category}`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }).then(response => {
        return true;
      });
    },

    setProductImageStatus(id, image, status) {
      const token = localStorage.getItem('auth_token');

      this.$http.put(`/products/${id}/images/${image.id}/ins/${status}/mark`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }).then(response => {
        return true;
      });
    },

    preparePriceGroup() {
      if ( this.product.type == 6 ) {
        this.product.priceGroups[0].priceGroupProducts = [];
        this.product.priceGroups[0].name = this.product.number;
        this.priceGroups.forEach((item)=>{
          this.product.priceGroups[0].priceGroupProducts.push({product: item.id});
        })
      }
    },

    removeProductFromPriceGroup(product) {
      this.priceGroups.forEach((item, index) => {
        if( item.id === product.id) {
          this.priceGroups.splice(index, 1);
        }
      })
    },

    refreshPreselectedImages() {
      this.$refs.globalSearch.getPreselectedImages();
    },

    goToProductEdit(id) {
      this.$router.push(`/product/${id}/edit`);
    },

    listLogoChange(event) {

      if ( event.added ) {

        this.product.productImages.main_logo = [];
        let logo            = event.added.element;
            logo.isChoosen  = 2;
        this.product.productImages.main_logo.push(logo);

        this.product.checklistMap.pageNumber = !this.product.checklistMap.pageNumber;
      }

    },

    listAdditionalLogoChange(event) {

      if ( event.added ) {
        let id            = event.added.element.id;
        let result        = this.product.productImages.additional_logo.find(item =>  item.id === id );
        result.isChoosen  = 1;

        let resultIndex   = this.product.productImages.additional_logo.findIndex(item =>  item.id === id );

        if ( this.product.productImages.additional_logo.length > 4 ) {
          this.product.productImages.additional_logo.splice(resultIndex, 1);
        }

      }
    },

    listImagesChange(event) {
      if ( event.added ) {
        let id      = event.added.element.id;
        let result  = this.product.productImages.photos.find(item =>  item.id === id );
        if ( this.product.productImages.photos.length == 1 || result.isChoosen === 2 ) {
          result.isChoosen = 2;
        } else {
          result.isChoosen = 1;
        }

        if ( this.product.productImages.photos.length > 1 ) {

          let indexes = [];

          this.product.productImages.photos = this.product.productImages.photos.filter((photo, index, self) =>
            index === self.findIndex((t) => (
              t.id === photo.id
            ))
          );

          let selected = this.product.productImages.photos.find(item => item.isChoosen == 2);
          if ( !selected && this.product.productImages.photos.length ) {
            this.product.productImages.photos[0].isChoosen = 2;
          }

        }

      }
    },

    listIconChange(event) {
      if ( event.added ) {
        let id      = event.added.element.id;
        let result  = this.product.productImages.icons.find(item =>  item.id === id );
        result.isChoosen = 1;

        let resultIndex   = this.product.productImages.icons.findIndex(item =>  item.id === id );

        if ( this.product.productImages.icons.length > 9 ) {
          this.product.productImages.icons.splice(resultIndex, 1);
        }
      }
    },

    listWatermarkChange(event) {
      if ( event.added ) {
        let id      = event.added.element.id;
        let result  = this.product.productImages.watermarks.find(item =>  item.id === id );
        result.isChoosen = 1;

        let resultIndex   = this.product.productImages.watermarks.findIndex(item =>  item.id === id );

        if ( this.product.productImages.watermarks.length > 2 ) {
          this.product.productImages.watermarks.splice(resultIndex, 1);
        }
      }
    },

    addColor(index) {
      if ( !this.selectedColors.includes(this.avaliableColors[index]) ) {
        this.selectedColors.push(this.avaliableColors[index]);
        this.setPlug('dostepny-w-kolorach', this.selectedColors)
      }
      this.product.colors.push(index);
    },

    getProducerLogoImage() {

      const token = localStorage.getItem('auth_token');

      let body = {
        phrase: this.product.producer,
      }
      this.$http.post(`product-images/producers/logos`, body, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if ( response.data.element ) {
          let image = response.data.element;
              image.isChoosen = 2;
              image.order = 1;
          this.product.productImages.main_logo = [];
          this.product.productImages.main_logo.push(image);
        }
      })
    },

    removeColor(index) {
      this.selectedColors.splice(index, 1);
      this.product.colors.splice(index, 1);
      this.setPlug('dostepny-w-kolorach', this.selectedColors.length > 0 ? true : false)
      return 
    },

    onSubmit(){
      this.preparePriceGroup();
      this.addProduct();
    },

    findMainImage(product){

      let image = product.productImages.find(image => image.isMain == true);
      if(image) return image.href;

    },

    setEnergeticClass(selected) {
      selected ? this.product.energeticClass = selected.value : this.product.energeticClass = '';
    },  

    setType() {
      if( this.product.view != 5 ) {
        this.product.type = 1;
        return;
      }
      this.product.type = 2;
    },

    writeProductName() {
      let producer  = this.product.producer.toLowerCase();
      let name      = this.product.name.toLowerCase();
      if ( !name.includes(producer) ) {
        let producer = this.product.producer.toUpperCase();
        this.product.name = `${producer} ${this.product.name}`;
      }
    },

    saveProductSelectedImages(id) {
      let _this = this;

      let data = [];
      this.product.productImages.additional_logo.forEach((image, index)=>{
        _this.setProductImage(id, image, 2);
        data.push({ id: image.id, order: index+1 });
      });
      this.saveProductImageSequences(id, 2, data);

      data = [];
      this.product.productImages.icons.forEach((image, index)=>{
        _this.setProductImage(id, image, 4);
        data.push({ id: image.id, order: index+1 });
      });
      this.saveProductImageSequences(id, 4, data);

      data = [];
      if(this.product.productImages.main_logo.length){
        this.product.productImages.main_logo.forEach((image, index)=>{
          _this.setProductImage(id, image, 1);
          data.push({ id: image.id, order: index+1 });
        });
        this.saveProductImageSequences(id, 1, data);
        this.setProductImageStatus(id, this.product.productImages.main_logo[0], 2);
      }

      data = [];
      this.product.productImages.photos.forEach((image, index)=>{
        _this.setProductImage(id, image, 3);
        data.push({ id: image.id, order: index+1 });
      });
      this.saveProductImageSequences(id, 3, data);

      data = [];
      this.product.productImages.watermarks.forEach((image, index)=>{
        _this.setProductImage(id, image, 5);
        data.push({ id: image.id, order: index+1 });
      });
      this.saveProductImageSequences(id, 5, data);

    },

    saveProductImageSequences( id, category, data ) {
      const token = localStorage.getItem('auth_token');
      const body = {
        images: data,
      };

      this.$http.post(`products/${id}/sequences/${category}`, body, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }).then(response => {
        return true;
      }).catch(error => {
        console.error(error.response);
      })
    },

    sortImages() {
      let keys = Object.keys(this.product.productImages);
      keys.forEach((item) => {
        this.product.productImages[item].forEach((image, index) =>{
          image.order = index + 1;
        });
      })
    },

    addProduct() {

      var _this = this;
      this.$v.$touch();

      this.sortImages();

      if ( this.dataFromOrder && this.product.pageNumber ) {
        const newPage = parseInt(this.product.pageNumber);
        const find    = this.dataFromOrder.pages.find(x => x.number === newPage);

        if ( !find ) {
          this.pageNumberError = 'Podana strona nie istnieje w zleceniu.';
          return;
        }

      }

      if (!this.$v.$invalid) {

        this.errorMessage = false;
        const token = localStorage.getItem('auth_token');

       if(this.dataFromOrder) {
          this.addProductToPage();
        } else {
          if ( this.product.isTemporary ) {
            var path = 'products/temporaries'; 
          } else {
            var path = 'products';
          }

          this.$http.post(path, this.product, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }).then(response => {
            this.successMessage = true;
            this.saveProductSelectedImages(response.data.id);

            setTimeout(()=>{
              _this.$router.push('/products');
            }, 1000);

          }).catch(error => {
            if ( error.response.data.message ) {
              this.errorMessage = true;
              this.errorMessagetext = error.response.data.message;
            }
          })
        }
        
      }

    },

    addProductToPage(){

      let order = this.dataFromOrder;

      const token = localStorage.getItem('auth_token');
      const find = this.dataFromOrder.pageId;

      if(find > 0) {

          this.$http.post(`order-pages/${find}/adds/news/products`, this.product, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }).then(response => {

            this.saveProductSelectedImages(response.data.id);
            localStorage.setItem('selectOrderPage', find);

            setTimeout(()=>{
              this.$router.push(`/order/${order.orderId}/edit`);
            }, 1000);

          }).catch(error =>{

            console.error(error)
           if ( error.response.data.message ) {
              this.errorMessage = true;
              this.errorMessagetext = error.response.data.message;
            }
          })

        }

        if(order.pageId == 0) {

          this.$http.post(`orders/${order.orderId}/adds/products`, this.product, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }).then(response => {
            this.saveProductSelectedImages(response.data.id);
            setTimeout(()=>{
              this.$router.push(`/order/${order.orderId}/edit`);
            }, 1000);
          }).catch(error =>{
            console.error(error)
            if ( error.response.data.message ) {
              this.errorMessage = true;
              this.errorMessagetext = error.response.data.message;
            }
          })

        }

    },

    checkPageNumber() {
      let find = this.dataFromOrder.pages.find(x => x.number === parseInt(this.product.pageNumber));
      if ( find ) {
        this.dataFromOrder.pageId = find.id;
      }
    },

  },
  mounted(){
    this.$root.$emit('menu');

    const communication = this.getDataFromStorage('OrderProduct');

    if(communication){

      this.dataFromOrder = communication;
      let pageNumber = communication.pages.find(x => x.id === communication.pageId);

      if ( pageNumber ) {
        this.product.pageNumber = pageNumber.number;
      }
      this.clearStorage('OrderProduct');

    }

  }
};
</script>

<style lang="scss" scoped>

.view-data__header {
  padding-left: 0;
  padding-right: 0;
}

.view-data__header h1 {
  display: inline-block;
  vertical-align: bottom;
  margin-top: 6px;
  margin-bottom: 8px;
  margin-right: 10px;
}

.view-product--add {
  padding: 0 15px;

  form {
  
    [class^="col"] {
      padding: 0 8px;
    }

    .container-fluid {
      padding: 0 8px;
    }

    .row {
      margin-left: -8px;
      margin-right: -8px;
    }

  }

}

.group {
    background-color: #F471FB;
    border-radius: 5px;
    padding:4px;
    color: #fff;

    & ~ .product--edit-bar{
      width:71%;
    }

    & svg polygon{
      fill: #fff;
    }
}

.product--edit-bar {
  width: 100%;
  max-width: 1390px;
  height: 31px;
  margin-bottom: 6px;
  display: inline-block;
  vertical-align: bottom;
  border-radius: 5px; 
  background-color: #c5c5c5;

  @media (max-width: 1400px) {
    max-width: 850px;
  }

  &.verified {
    background-color: #2ECC71;
  }

  &.verified-temp {
    background-color: #2ECC71 !important;
  }

  &.temporary {
    background-color: #F7BA5A;
  }

  .form-group {

    width: auto;
    display: inline-block;
    vertical-align: top;
    margin-top: 4px;

    @media (max-width: 1400px) {
      
    }

    label {
      font-size: 12px;
      font-weight: bold;
      @media (max-width: 1400px) {
        font-size: 1.2rem;
      }
    }

    input, select {
      font-size: 1.4rem;
      @media (max-width: 1400px) {
        font-size: 1.4rem;
      }
    }

    .form-control {
      line-height: 1.8rem;
      color: #ffffff;
      border-bottom-color: #ffffff;
      opacity: 1;
      font-weight: 600;

      @media (max-width: 1400px) {
        line-height: 1.4rem;
      }

    }

    &--checkbox {

      float: right;
      margin: 7px 10px 0;

      .checkbox--name {
        color: #ffffff;
        font-weight: 600;
      }

    }

    &.product-index {
      width: 100px;
      margin: 4px 20px;
    }

    &.product-page {

      label, input {
        display: inline-block;
        vertical-align: middle;
      }

      label {
        margin-right: 10px;
        color: #ffffff;
        opacity: 0.7;
        margin-bottom: 0;
        margin-top: 2px;
        @media (max-width: 1400px) {
          line-height: 1.2rem;
        }
      }

      input {
        width: 48px;
        padding: 0 4px;
      }
    }

    &.product-name {
      width: 400px;
      margin: 4px 20px;
    }

  }

}

.button-add-product {

  border: none;
  height: 47px; 
  width: 179px; 
  background-color: #E3000A;
  padding: 15px 69px;
  color: #FFFFFF; 
  font-size: 14px;  
  letter-spacing: 0.12px; 
  line-height: 17px; 
  outline: none;
  float: right;

  &:focus {
    outline: none;
  }

  &.mt-10 {
    text-decoration: none;
    color: #E3000A;
    background: #ffffff;
    border: 1px solid #E3000A;
  }

}

.no-padding {
  padding: 0 !important;
}

.padding-4 {
  padding: 0 4px !important;
}

.pr-25 {
  padding-right: 25px !important;
}

.mt-25 {
  margin-top: 25px;
}

.col-bordered {
  border: 1px solid #E3000B;
  background-color: #F8F8F8;
  padding: 10px !important;
}

.product--details {
  padding: 10px 10px;
  background-color: #C5C5C5;
  margin-bottom: 10px;
}

.product--prices {
  padding: 10px 10px;
  background-color: #FFF3F3;
  margin-bottom: 10px;
}

.product--dates {
  padding: 10px 10px;
  background-color: #FFF7E9;
  margin-bottom: 10px;

}

.product--images {
  padding: 10px 0px;
  background-color: transparent;
  margin-bottom: 10px;
}

.product--lagals,
.product--technical-details {
  padding: 10px 10px;
  margin-bottom: 10px;
  background-color: #FFFFFF;
}

.product--lagals {
  margin-bottom: 0;
}

.form-group {

  label {
    opacity: 1;
    white-space: nowrap;
    font-size: 12px;
    font-weight: bold;
    @media (max-width: 1400px) {
      font-size: 1rem;
    }

    &.light {
      font-weight: 400;
    }
  }

  input, select {
    font-size: 1.4rem;
    @media (max-width: 1400px) {
      font-size: 1.2rem;
    }
  }

  &--checkbox,
  &--padding {

    padding-left: 30px;

    @media (max-width: 1400px) {
      padding-left: 20px;
    }

  }

  &--date {

    position: relative;

    span.date {

      right: 0px;
      bottom: 5px;
      position: absolute;
      width: 18px;
      height: 18px;

    }
  }

  &.hide-date {
    span.date {
      display: none;
    }
  }

  &--small {

    margin-bottom: 0;

    label {
      font-size: 0.9rem;
      margin-bottom: 0;
    }

    input {
      font-size: 1.4rem;
      padding: 0 1rem;
      opacity: 1 !important;
      @media (max-width: 1400px) {
        font-size: 1.2rem;
      }
    }
  }

  .form-control {
    padding: 0;
  }

  &--checkbox {

    position: relative;

    input {

    }

    label {
      cursor: pointer;
      color: #3E4A59;
      font-weight: 400;
      opacity: 1;
    }

    .checkbox {

      &--state {
      
        position: absolute;
        left: 6px;

        width: 1.8rem;
        height: 1.8rem;
        border-radius: 4px;
        background-color: #fff;
        border: 1px solid #DFE3E9;

        @media (max-width: 1400px) {
          width: 1.4rem;
          height: 1.4rem;
          left: 2px;
        }

        &:after {
          position: absolute;
          content: '';
          top: 50%;
          left: 25%;
          width: 5px;
          height: 10px;
          border: solid #939393;
          border-width: 0 2px 2px 0;
          opacity: 0;
          transition: all 0.25s ease;
          transform: rotate(45deg) translate(-50%,-50%);

          @media (max-width: 1400px) {
            width: 4px;
            height: 8px;
          }

        }
      }

      &--name {

        font-size: 1.2rem;
        color: #3E4A59;
        font-weight: 400;
        font-weight: bold;

        @media (max-width: 1400px) {
          font-size: 1rem;
          white-space: nowrap;
        }

      }

    }

    input:checked ~ .checkbox--state:after {
      opacity: 1;
    }

  }
  
  .form-control-textarea {

    min-height: 150px;
    line-height: 30px;
    resize: none;
    padding: 0;

    background: linear-gradient(
      to bottom,
      transparent,
      transparent 29px,
      #E4EAEE 1px,
      #E4EAEE
    );
    border-bottom: none;
    font-size: 1.4rem;
    color: #24272B;
    opacity: 0.8;
    background-size: 100% 30px;

    @media (max-width: 1400px) {
      font-size: 1.2rem;
    }

    &:focus {
      outline: none;
      border:none;
      box-shadow: none;
    }

  }

}

.colors-list {

  box-shadow: 0 1px 4px 0 rgba(0,0,0,0.08);
  padding: 3px;
  margin: 0;
  text-align: left;

  p {
    opacity: 0.5;  
    color: #000000; 
    font-size: 9px; 
    letter-spacing: 0.12px; 
    line-height: 17px;
    margin: 0;
    text-transform: uppercase;
  }

  li {
    padding: 1px;
    vertical-align: middle;
  }

  .square {
    width: 20px;
    height: 20px;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid #DFE3E9;

    @media (max-width: 1400px) {
      width: 1.7rem;
      height: 1.7rem;
    }
  }

}

.selected-colors {
  height: 30px;
  width: 100%;
  margin-bottom: 5px;
  border-bottom: 1px #d3dfef solid;

  margin: 0;
  padding: 3px;
  text-align: left;

  li {
    padding: 1px;
    vertical-align: middle;
  }

  .square {
    width: 20px;
    height: 20px;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid #DFE3E9;
    @media (max-width: 1400px) {
      width: 1.7rem;
      height: 1.7rem;
    }
  }

}

.form-group--small-padding.row {
  margin-left: -7.5px !important;
  margin-right: -7.5px !important;
  .form-group--small {
    padding: 0 7.5px;
  }
}

.section-header {
  max-width: 308px;
  color: #4A4A4A;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.12px;
  line-height: 18px;
  padding-bottom: 5px;
  border-bottom: 1px solid #E3000A;
  margin-bottom: 15px;
}

.icons-list {
  margin-left: 0;
  max-width: 285px;
  min-height: 195px;
}

.icons-list li {
  &.is-main {
    border: 1px solid #2ecc71;
    background-color: rgba(46, 204, 113, 0.14);
  }

  &.is-choosen {
    border: 1px solid #f9a118;
    background-color: #f7ebd7;
  }

  &:nth-of-type(even) {
    margin-right: 11px !important;
  }
}

.small-icon-list-element {

  position: relative;
  height: 54px; 
  width: 87px;
  vertical-align: top;
  border: 2px solid #979797; 
  background-color: #FFFFFF;
  margin-right: 11px;
  margin-bottom: 11px;

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    max-width: 90%;
    max-height: 90%;
  }

  @media (max-width: 1400px) {
    height: 54px; 
    width: 32%; 
    margin-right: 2%;
  }

  &.is-main {
    border: 1px solid #2ecc71;
    background-color: rgba(46, 204, 113, 0.14);
  }

  &.is-choosen {
    border: 1px solid #f9a118;
    background-color: #f7ebd7;
  }

}

.watermarks-list .small-icon-list-element {
  &:nth-of-type(even) {
    margin-right: 11px !important;
  }
}

.icons-list--duplicated {
  margin-left: 0;
  position: absolute;
  top: 0;
  left: 0;
  max-width: 285px;
}

.icons-list li {
  &:nth-of-type(3n) {
    margin-right: 0px !important;
  }
}

.icons-list--duplicated li {

  position: relative;
  height: 54px; 
  width: 87px;
  vertical-align: top;
  border: 1px solid #979797; 
  background-color: #FFFFFF;
  margin-right: 11px;
  margin-bottom: 11px;

  @media (max-width: 1400px) {
    height: 54px; 
    width: 32%; 
    margin-right: 2%;
  }

  &.is-main {
    border: 2px solid #2ecc71;
    background-color: rgba(46, 204, 113, 0.14);
  }

  &.is-choosen {
    border: 1px solid #f9a118;
    background-color: #f7ebd7;
  }

  &.small-icon-list-element:nth-of-type(even) {
    margin-right: 11px;
  }

  &:nth-of-type(3n) {
    margin-right: 0;
  }
}

.form-group.input-error > input {
  height: auto !important;
  padding-bottom: 0 !important;
}

.form-group.input-error > select {
  border-bottom: 2px #e3000b solid !important;
}

.preselected__images--wrapper {
  height: 520px;
}

.preselected__images {

  padding: 5px 7px;
  max-width: 92%;

  &.empty {
    max-width: 100%;
    padding: 0;
  }

  &::-webkit-scrollbar {
    width: 8px;
    padding: 3px;
  }

  &::-webkit-scrollbar-track {
    background-color: #D8D8D8;
    border-radius: 7px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    width: 5px;
    border-radius: 4px;
    background-color: #939393;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #939393; 
  }

  &::-webkit-scrollbar-button {
    display: none;
  }

  li {

    position: relative;
    float: left;
    width: 45%;
    min-height: 90px;
    margin-right: 8%;
    margin-bottom: 14px;
    border: 1px solid #0E0E0E;

    @media (max-width: 1400px) {
      width: 100%;
      margin-right: 0;
    }

    &.is-choosen {
      border: 1px solid #f9a118;
      background-color: #f7ebd7;
    }

    &.is-main {
      border: 1px solid #2ecc71;
      background-color: rgba(46, 204, 113, 0.14);
    }

    &:nth-of-type(even) {
      margin-right: 0;
    }

    .name {
      position: absolute;
      bottom: -9px;
      left: -7px;
      color: #000000; 
      font-size: 7px; 
      letter-spacing: 0.07px; 
      line-height: 17px;
      padding: 0px 10px;
      background-color: #ffffff;
      border-radius: 5px;
      min-width: 70%;
    }

    .not-accepted {
      position: absolute;
      top: -5px;
      right: -7px;
      width: 14px;
      height: 14px;
      color: #ffffff;
      font-size: 10px;
      line-height: 15px;
      font-weight: 500;
      border-radius: 50%;
      text-align: center;
      cursor: pointer;
      background-color: #E3000A;
    }

    .info {
      position: absolute;
      top: -5px;
      left: -7px;
      width: 14px;
      height: 14px;
      color: #ffffff;
      font-size: 10px;
      line-height: 13px;
      font-weight: 500;
      border-radius: 50%;
      text-align: center;
      cursor: pointer;
      background-color: #5CA6FF;
      z-index: 10000;
  
      &:hover {
        .image-info-content {
          display: block;
          margin-left: 0;
        }
      }

    }

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 90%;
      max-height: 90%;
    }

  }

}

.row {
  margin-right: -8px;
  margin-left: -8px;
}

.col {
  padding-left: 8px;
  padding-right: 8px;
}

input[type="date"] {
  line-height: 1.5 !important;
}

.copy-product-button {

  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 10px;
  line-height: 1;
  margin-top: -2px;
  letter-spacing: 0.08px;
  vertical-align: text-top;

  svg {
    width: 14px;
    height: 14px;
  }

}

.list--logo {

  width: 100%;
  position: relative;
  height: 53px;
  width: 100%;

  .product-image-logo {
    width: 100%;
    height: 100%;
    position: relative;
    transition: all 0.45s ease;
    border: 1px solid #000000;
    background-color: rgba(131, 131, 131, 0.7);

    &.is-main {
      border: 1px solid #2ecc71;
      background-color: rgba(46, 204, 113, 0.14);

      img {
        opacity: 1;
      }

    }

    &.is-choosen {
      border: 1px solid #f9a118;
      background-color: #f7ebd7;
    }

    .name--zoom img {
      opacity: 1 !important;
    }

    &.is-choosen {
      border: 1px solid #f9a118;
      background-color: #f7ebd7;
    }

    img {

      position: absolute;
      opacity: 0.5;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      max-width: 90%;
      max-height: 90%;
      text-align: center;

    }

  }

}

.list--additional-logo {
  margin-left: 0;
  position: relative;

  img {

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 90%;
    height: auto;

  }

}

.list--additional-logo li {

  min-height: 55px;
  vertical-align: top;
  width: 46%; 
  position: relative;
  margin-right: 6%;
  border: 1px solid #979797; 
  background-color: #FFFFFF;
  margin-bottom: 10px;
  padding: 0;

  &.is-main {
    border: 1px solid #2ecc71;
    background-color: rgba(46, 204, 113, 0.14);
  }

  &.is-choosen {
    border: 1px solid #f9a118;
    background-color: #f7ebd7;
  }

  &:nth-of-type(even) {
    margin-right: 0;
  }

  img {

    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-width: 90% !important;
    max-height: 90% !important;
    width: auto !important;

  }

  .name--zoom img {
    width: 9px;
    height: 9px;
  }
}

.image--remove {
  height: 10.4px; 
  width: 10.06px;
  position: absolute;
  bottom: -4px;
  right: -4px;
  overflow: hidden;
  cursor: pointer;
  background-color: #FFFFFF;

  svg {
    height: 10.4px; 
    width: 10.06px;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.product__price-group {

  .price-group--add {

    float: right;
    cursor: pointer;
    height: 47px; 
    width: 179px; 
    background-color: #E3000A;
    color: #FFFFFF; 
    font-size: 16px;  
    line-height: 47px;  
    text-align: center;
    text-transform: uppercase;

  }

}

.price-group--list {
  height: 276px;
  width: calc(100% - 15px);
}

.price-group--element {

    border-bottom: 2px solid #B9B9B9;
    padding-bottom: 5px;
    margin-bottom: 5px;

}


.price-group--element-content {
  
  width: calc(100% - 75px);
  height: 58px;
  padding-top: 24px;
  display: inline-block;
  vertical-align: bottom;
  position: relative;

  p, a {
    color: #000000;
    font-size: 12px;
    letter-spacing: 0.12px; 
    line-height: 17px;
    height: 17px;
    max-height: 17px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin-bottom: 0;
    font-weight: 400;
    text-decoration: none;
    
    &:last-of-type {
      padding-bottom: 2px;
    }

  }

  .remove {
    height: 14px;
    width: 14px;
    position: absolute;
    top: 2px;
    left: 2px;
    overflow: hidden;
    cursor: pointer;
    background-color: #FFFFFF;

    svg {
      position: absolute;
      top: 0;
      left: 0;
      cursor: pointer;
    }
  }

}

.price-group--element-image {

  width: 75px;
  height: 58px;
  border: 1px solid #000000;  
  background-color: #E9E9E9;
  display: inline-block;
  vertical-align: bottom;
  position: relative;

  img {

    display: block;
    max-width: 100%;
    max-height: 100%;
    top: 50%;
    position: absolute;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);

  }
}

.icons-relative-wrapper {
  position: relative;
}

.watermarks-list li,
.watermarks-list--duplicated li {
  position: relative;
  height: 54px; 
  width: 87px;
  vertical-align: top;
  border: 1px solid #979797; 
  background-color: #FFFFFF;
  margin-right: 11px;
  margin-bottom: 11px;

  @media (max-width: 1400px) {
    height: 54px; 
    width: 32%; 
    margin-right: 2%;
  }

  &.is-main {
    border: 2px solid #2ecc71;
    background-color: rgba(46, 204, 113, 0.14);
  }

  &.is-choosen {
    border: 1px solid #f9a118;
    background-color: #f7ebd7;
  }

  &:nth-of-type(3n) {
    margin-right: 11px;
  }

  &:nth-of-type(2) {
    margin-right: 0;
  }

  img {
    top: 50%;
    left: 50%;
    max-width: 90%;
    max-height: 90%;
    transform: translate(-50%,-50%);
  }
}

.watermarks-list,
.watermarks-list--duplicated {
  margin-left: 0;
  width: 200px;
  height: 130px;
}

.watermarks-list--duplicated {
  position: absolute;
  top: 0;
  left: 0;
}

.mt-10 {
  margin-top: 10px;
}

.empty-drag-area {
  border: 1px solid #000000;
  font-size: 11px;
  width: 100%;
  text-align: center;
  line-height: 40px;
}

.padding-bottom-50 {
  padding-bottom: 50px !important;
}

.buttons--wrapper {
  position: absolute;
  bottom: 10px;
  right: 10px;

  button, a {
    float: none;
    display: inline-block;
    margin-left: 10px;
    vertical-align: bottom;
  }
}

.graphic-control{
  justify-content: flex-end;
}

.preselected__images--wrapper .__panel{
  overflow: auto;
}

</style>
